import { Component, OnInit, ViewChild, ElementRef, Input, ChangeDetectorRef, Injectable, OnChanges } from '@angular/core';

import { Observable } from 'rxjs/Observable';
import { Http, Headers, Request, Response, RequestOptions } from '@angular/http';
import { GoogleService } from '../shared/Google.service'
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';
import { Book } from '../shared/models/book';
import * as _ from 'lodash';
import { AlbumData } from '../shared/models/albumData';
import { AlbumPouchDb } from './album.pouchService';

import { MatSnackBar } from '@angular/material';
import { HttpModule } from '@angular/http';
import { SortablejsOptions } from 'angular-sortablejs';
import { Component_interactionService } from '../component_interaction.service';
@Component({
  selector: 'app-album',
  templateUrl: './album.component.html',
  styleUrls: ['./album.component.css']
})

export class AlbumComponent implements OnInit{
  ratioArray: any=[];
  heightArray: any;
  widthArray: any;

  isDisableLeftArrow: boolean = true;
  isDisableRightArrow: boolean = false;

  @ViewChild('albumAddImg', { read: ElementRef }) public albumAddImg: ElementRef;
  @ViewChild('slideImageParentContainer', { read: ElementRef }) public slideImageParentContainer: ElementRef;
  albumImgArray: any = [];
  deleteArr: any = [];
  album_id: any;
  // ShelfPouchDb:ShelfPouchDb
  albumContent: any;
  changeMediaColor: boolean = false;
  changePreviewcolor: boolean = false;
  checked = <boolean>{}
  albumData: any = [{}]
  str: any
  isLoader = false;
  options;
  
  arrowClicked: boolean = false;
  constructor(public GoogleService: GoogleService, private cdr: ChangeDetectorRef, public albPouchDb: AlbumPouchDb,public snackBar:MatSnackBar,private Component_interactionService:Component_interactionService) { 
    this.options = {
      onUpdate: (event: any) => {
       
        // this.postChangesToServer();
      }
    };
  }
  AlbumData = new AlbumData();

  slideIndex: number = 1;

  tempUrl: any = [];
  dummyUrl: any = [];
  imageurl: any;
  deleteIcon: boolean = true;
  isPreviewEnabled: boolean = false;
  selectedImageInd;
  curImageConInd = 0;

  imageIndex=0;

  @Input() data: any
  public pdfObj;
  public bookObj: Book;
  public totalPdfPages;
  public enrichmentTabsScope;
  public youtubeSrc = "";
  public dataObj;
  public showPreview: boolean = false;
  conatinerHeight;
  containerWidth;
  ImageWidthVal;
  ImageHeightVal;

  @ViewChild('spinner') spinner: ElementRef;

  ngOnInit() {
    
 
    this.pdfObj = this.data.bookObj;
    this.albPouchDb.getAlbData(this)

    

    // this.cdr.detectChanges();

  }

  selectImages() {

    if(!localStorage.userData || localStorage.userData == 'undefined'){
      this.openSnackBar('please login', '');
    }else{
      this.albumAddImg.nativeElement.click();
    }
    
  }
  openSnackBar(message: string, action: string) {
    this.snackBar.open(message, action, {
      duration: 2000,
    });
  }

  ngAfterViewInit() {
    this.cdr.detectChanges();
  }

  selectedImgs = [];

  updateDeleteArr(ind) {

    let index = _.indexOf(_.map(this.selectedImgs, 'id'), ind);
    if (index != -1) {
      this.selectedImgs.splice(index, 1);
    } else {
      let obj = { id: ind };
      this.selectedImgs.push(obj);
    }
  }

  // imageData(id, url) {
  //   var data = {
  //     "img_id": id,
  //     "image_url": url

  //   }
  //   this.tempUrl.push(data)
  //   this.dummyUrl.push(data)
  // }


  readUrl(event: any) {

    this.albumContent = event
    this.changeMediaColor = false;
    console.log(event)


    for (let j = 0; j < event.target.files.length; j++)
      if (event.target.files && event.target.files[j]) {
        document.getElementsByClassName('showApploader')[0].classList.add('hideApploader');
        console.log(event.target.files[0].type)
        if (event.target.files[0].type == "image/png" || event.target.files[0].type == "image/jpg" || event.target.files[0].type == "image/jpeg" || event.target.files[0].type == "image/gif" || event.target.files[0].type == "image/tif") {
          this.GoogleService.insertFileintofloder(this.albumContent.target.files[j], this.albumContent.target.files[j], localStorage.currentDriveMediaId, false, this);
        }
        else {
          document.getElementsByClassName('showApploader')[0].classList.remove('hideApploader');
          this.cdr.detectChanges();
          alert("please add image type files")
          return;
        }

        // var reader = new FileReader();
        // reader.onload = (event: any) => {
        //   this.imageurl = event.target.result;
        //   var date=Date.now()
        //   this.imageData(date,this.imageurl)

        //   this.albumImgArray.push(this.imageurl)

        // }


        // reader.readAsDataURL(event.target.files[j]);

      }
    // this.updateAlbumData();






  }
  insertAlbumData(file) {

    var doc = new AlbumData();
    var date = Date.now();
    doc.imageUrls = this.tempUrl;
    doc.type = "albumData";
    doc.owner = "webuser444";
    doc._id = "webuser444." + String(Date.now()) + ".albumData";
    // doc.imageDriveData={
    //   'id':file.id,
    //   'url':this.tempUrl
    // }

    this.albPouchDb.createAlbum(doc, this);

  }
  
  imgDelete(event, i) {
    console.log("img delete" + event);

  }
  imageAddedIntoDrive(file) {
    console.log(file);


    // this.tempUrl = [];
    // let obj = {
    //   id:  Date.now(),
    //   image_url: file.thumbnailLink
    // }

    if (!file.error) {
      if (this.tempUrl.length != 0) {
        //    this.tempUrl.push(file.thumbnailLink);
      
        this.tempUrl.push(file.webContentLink.substring(0, file.webContentLink.indexOf("&export")));
        this.insertAlbumData(file);

      }
      else {

        this.tempUrl.push(file.webContentLink.substring(0, file.webContentLink.indexOf("&export")));
        this.insertAlbumData(file);

      }

    }
    else {
      document.getElementsByClassName('showApploader')[0].classList.remove('hideApploader');
      this.cdr.detectChanges();
      //alert("please login to the application")

      return false;
    }
  }

  // afterImagesLoad(img) {
  //   if (img.length == 0) {
  //     that.isLoader = false;
  //     that.cdr.detectChanges();
  //   }
  //   for (var i = 0; i < img.length; i++) {

  //     var that = this;
  //     if (i == img.length - 1) {
  //       var image = new Image();
  //       image.src = img[img.length - 1];

  //       image.onload = function () {
  //         that.isLoader = false;
  //         that.cdr.detectChanges();
  //       }
  //     }
  //     else if (img.length == 0) {
  //       that.isLoader = false;
  //       that.cdr.detectChanges();
  //     }
  //     // else
  //     // {
  //     //   that.isLoader=false;
  //     //   that.cdr.detectChanges();
  //     // }
  //   }


  // }

//   imageResize(){

//     for(var i=0;i<this.tempUrl.length;i++){
//       var img = new Image();
//       img.src = this.tempUrl[i];
      
//      var imagewidth = img.naturalWidth;
//        var  imageheight = img.naturalHeight;

//        var ratio=imagewidth/imageheight;

//        this.ratioArray.push(ratio)
        
//  var imageNewHeight=this.containerWidth/ratio;
//  var imageNewWidth=imageNewHeight*ratio
//  this.heightArray.push(imageNewHeight);
//  this.widthArray.push(imageNewWidth);
 
//     }
//   }
stopLoader(){
 
  setTimeout(()=>{   
    document.getElementsByClassName('showApploader')[0].classList.remove('hideApploader');
    this.cdr.detectChanges();
},3000);

}
  loadImages(response) {

    // this.tempUrl=[];
      this.tempUrl = response.docs[0].imageUrls;
      setTimeout(()=>{   
        document.getElementsByClassName('showApploader')[0].classList.remove('hideApploader');
        this.cdr.detectChanges();
    },3000);
  }
  loadInitialImages(response) {

    this.ratioArray=[];
    var self = this
    if (response.docs[0].imageUrls.length != 0 && response.docs[0].imageUrls !="undefined") {
      document.getElementsByClassName('showApploader')[0].classList.remove('hideApploader');
      self.tempUrl = [];
      self.tempUrl = response.docs[0].imageUrls
      // this.dummyUrl = response.docs[0].imageUrls

      document.getElementsByClassName('showApploader')[0].classList.remove('hideApploader');
       this.cdr.detectChanges();

      // this.afterImagesLoad(this.tempUrl)

      if (this.tempUrl.length > 0) {

        this.showPreview = true
      }
      else {
        this.showPreview = false;
      }

      if (this.tempUrl.length == 1) {
        this.isDisableLeftArrow = true;
        this.isDisableRightArrow = true
      }
      else {
        this.isDisableLeftArrow = true;
        this.isDisableRightArrow = false
      }

    }
    else {
      document.getElementsByClassName('showApploader')[0].classList.remove('hideApploader');
       this.cdr.detectChanges();
    }
  }


  updateCreateFolderID(id) {

    this.GoogleService.insertFileintofloder(this.albumContent.target.files[0], this.albumContent.target.files, id, false, this);

  }


  deleteImg() {


    var doc = new AlbumData();
    var date = Date.now();
    doc.imageUrls = this.tempUrl;
    doc.type = "albumData";
    doc.owner = "webuser444";
    doc._id = "webuser444." + String(Date.now()) + ".albumData";


    document.getElementsByClassName('showApploader')[0].classList.add('hideApploader');
    for (var i = this.tempUrl.length - 1; i >= 0; i--) {
      if (this.checked[i]) {

       
        //delete row from data
        delete this.checked[i];
        var dirveUrlsToDelete= this.tempUrl[i]
        this.tempUrl.splice(i, 1);
      }
    }
    this.selectedImgs = [];
   
    // this.albPouchDb.updateAlbData(this)
    this.albPouchDb.createAlbum(doc,this)
  }

  closeAlbumView() {
    var temp = {}
    this.Component_interactionService.selectedBookData(temp);
    this.data.appendComponentsToApp('shelf');
   
  }

  preview(event) {
    console.log(event);

    if (this.showPreview == false) {
      this.showPreview = true
      this.deleteIcon = false;
      if (this.tempUrl.length == 1) {
        this.isDisableRightArrow = true;
        this.isDisableLeftArrow = true;
      }
      if (this.tempUrl.length > 1) {
        this.isDisableRightArrow = false;
        this.isDisableLeftArrow = true;
      }
      if (this.tempUrl.length - 1 == this.curImageConInd && this.tempUrl.length > 1) {
        this.isDisableRightArrow = true;
        this.isDisableLeftArrow = false;
      }
      if (this.curImageConInd > 0 && this.tempUrl.length - 1 != this.curImageConInd) {
        this.isDisableRightArrow = false;
        this.isDisableLeftArrow = false;
      }
    }
    else {
      this.showPreview = false;
      this.deleteIcon = true;
    }

  }
  sortImages(ev){

    this.checked = <boolean>{};
    this.selectedImgs = [];

    var doc = new AlbumData();
    var date = Date.now();
    doc.imageUrls = this.tempUrl;
    doc.type = "albumData";
    doc.owner = "webuser444";
    doc._id = "webuser444." + String(Date.now()) + ".albumData";

    this.cdr.detectChanges();
    this.albPouchDb.createAlbum(doc,this);
  }
  displayDeleteOption(event) {
    event.stopPropagation();
    if (!this.deleteIcon) {
      this.deleteIcon = true;
    }
  }
  ratio;
  heightAfterAspectRatio;
  widthAfterAspectRatio 
  heightAfterAspect
  widthAfterAspect
  plusDivs(n, state) {


    
    if (state == 'right') {
      if (this.tempUrl.length - 1 != this.curImageConInd) {
        this.isDisableLeftArrow = false;
        this.isDisableRightArrow = false;
        this.curImageConInd++;
        this.imageIndex++;
        var image = new Image();
        image.src = this.tempUrl[this.imageIndex];
        var that = this;
        image.onload =  (()=>{
          that.ImageWidthVal = image.naturalWidth+'px';
          that.ImageHeightVal = image.naturalHeight+'px';
        // that.ratio= that.ImageWidthVal/ that.ImageHeightVal;
        // that.heightAfterAspectRatio=600/that.ratio;

        // that.widthAfterAspectRatio=that.heightAfterAspectRatio*that.ratio;
        // that.heightAfterAspect= that.heightAfterAspectRatio+'px';
        // that.widthAfterAspect=  that.widthAfterAspectRatio+'px';
        })
       
  

        this.arrowClicked = false;
        if (this.curImageConInd == this.tempUrl.length - 1) {
          this.isDisableRightArrow = true;
          this.isDisableLeftArrow = false;
        }


      }
      if (this.tempUrl.length == 1) {
        this.isDisableRightArrow = true;
        this.isDisableLeftArrow = true;
      }
    } else {
      this.imageIndex--;
      var image = new Image();
      image.src = this.tempUrl[this.imageIndex];
      var that = this;
      image.onload =  (()=>{
        that.ImageWidthVal = image.naturalWidth+'px';
        that.ImageHeightVal = image.naturalHeight+'px';
      
      }) ;
     

      if (this.curImageConInd != 0) {
        this.isDisableLeftArrow = false;
        this.isDisableRightArrow = false;
        this.curImageConInd--;
        this.arrowClicked = true;
        if (this.curImageConInd == 0) {
          this.isDisableLeftArrow = true;
          this.isDisableRightArrow = false;
        }

      }
    }
  }

  // getShelfData(file, i) {

  //   file;

  // }
  // showAllBookRecords() {

  // }

  // showDivs(n) {
  //   var i;
  //   var x = document.getElementsByClassName("mySlides");
  //   if (n > x.length) {this.slideIndex = 1}    
  //   if (n < 1) {this.slideIndex = x.length}
  //   for (i = 0; i < x.length; i++) {
  //      x[i].style.display = "none";  
  //   }
  //   if( x[this.slideIndex-1]){
  //     x[this.slideIndex-1].style.display = "block";  
  //   }

  // }

}




// WEBPACK FOOTER //
// ./src/app/album/album.component.ts